import Browser from '@wetransfer/concorde-browser';

import StaticPage from '@component/panel/content';

if (Browser.isMobile) {
  StaticPage.configure('/', (instance) => {
    instance.subscribeToStore = true;

    const iOSButton = instance.node.querySelector('#get-ios-app');
    const androidButton = instance.node.querySelector('#get-android-app');

    if (Browser.isAndroid) {
      androidButton.style.display = 'block';
    } else {
      iOSButton.style.display = 'block';
    }
  });
}
